export const LOCAL_STORAGE_KEYS = {
    // ILOE banner related keys
    iloe: {
        dashboardRenewalBanner: 'VIEWED_DASHBOARD_RENEWAL_BANNER',
        beforeRenewal: 'VIEWED_BEFORE_RENEWAL_BANNER',
        afterRenewal: 'VIEWED_AFTER_RENEWAL_BANNER',
    }
}